import a, { useContext as i, createContext as u } from "react";
import o from "../../../tiny-invariant/dist/esm/tiny-invariant.js";
import P from "../../../../_virtual/find.js";
import g from "../../../../_virtual/every.js";
import { calculateViewBox as N } from "../util/calculateViewBox.js";
import { getAnyElementOfObject as f } from "../util/DataUtils.js";
function s(t) {
  "@babel/helpers - typeof";
  return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, s(t);
}
var c = /* @__PURE__ */ u(void 0), v = /* @__PURE__ */ u(void 0), l = /* @__PURE__ */ u(void 0), h = /* @__PURE__ */ u({}), x = /* @__PURE__ */ u(void 0), p = /* @__PURE__ */ u(0), m = /* @__PURE__ */ u(0), W = function(e) {
  var r = e.state, n = r.xAxisMap, C = r.yAxisMap, d = r.offset, A = e.clipPathId, b = e.children, E = e.width, O = e.height, w = N(d);
  return /* @__PURE__ */ a.createElement(c.Provider, {
    value: n
  }, /* @__PURE__ */ a.createElement(v.Provider, {
    value: C
  }, /* @__PURE__ */ a.createElement(h.Provider, {
    value: d
  }, /* @__PURE__ */ a.createElement(l.Provider, {
    value: w
  }, /* @__PURE__ */ a.createElement(x.Provider, {
    value: A
  }, /* @__PURE__ */ a.createElement(p.Provider, {
    value: O
  }, /* @__PURE__ */ a.createElement(m.Provider, {
    value: E
  }, b)))))));
}, F = function() {
  return i(x);
};
function y(t) {
  var e = Object.keys(t);
  return e.length === 0 ? "There are no available ids." : "Available ids are: ".concat(e, ".");
}
var S = function(e) {
  var r = i(c);
  r == null && (process.env.NODE_ENV !== "production" ? o(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : o());
  var n = r[e];
  return n == null && (process.env.NODE_ENV !== "production" ? o(!1, 'Could not find xAxis by id "'.concat(e, '" [').concat(s(e), "]. ").concat(y(r))) : o()), n;
}, T = function() {
  var e = i(c);
  return f(e);
}, X = function() {
  var e = i(v), r = P(e, function(n) {
    return g(n.domain, Number.isFinite);
  });
  return r || f(e);
}, Y = function(e) {
  var r = i(v);
  r == null && (process.env.NODE_ENV !== "production" ? o(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : o());
  var n = r[e];
  return n == null && (process.env.NODE_ENV !== "production" ? o(!1, 'Could not find yAxis by id "'.concat(e, '" [').concat(s(e), "]. ").concat(y(r))) : o()), n;
}, H = function() {
  var e = i(l);
  return e;
}, j = function() {
  return i(h);
}, k = function() {
  return i(m);
}, L = function() {
  return i(p);
};
export {
  p as ChartHeightContext,
  W as ChartLayoutContextProvider,
  m as ChartWidthContext,
  x as ClipPathIdContext,
  h as OffsetContext,
  l as ViewBoxContext,
  c as XAxisContext,
  v as YAxisContext,
  T as useArbitraryXAxis,
  L as useChartHeight,
  k as useChartWidth,
  F as useClipPathId,
  j as useOffset,
  H as useViewBox,
  S as useXAxisOrThrow,
  Y as useYAxisOrThrow,
  X as useYAxisWithFiniteDomainOrRandom
};
